import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

import { duplicateTaskGroup } from '../api/task-groups-api' ;

import { removeTasks, archiveTasks, completeTasks } from '../actions/tasks';
import { createMilestone } from '../actions/milestones';
import { updateTaskGroup, removeTaskGroup, moveAllTaskGroupTasks, fetchTaskGroups, setTaskGroupVisibility, assignTaskGroup, unassignTaskGroup, tieToMilestone, untieFromMilestone } from '../actions/task-groups';
import { updateTaskGroup as updateTaskGroupApi } from '../api/task-groups-api';

import config from 'config/index';
import { trackEvent } from '../services/events-tracker-service';

import { RolesAndPermissionsContext } from 'context/RolesAndPermissionsContext';

import EditPanel from './edit-panel';
import DropdownBtn from './dropdown-btn';
import OverflowTooltip from './overflow-tooltip';
import UsersList from './users-list';
import FeatureAvailable from './feature-available';
import CustomFields from './custom-fields';
import HideFrom from './hide-from';
import Tooltip from './tooltip';
import NotificationsBubble from 'components/NotificationsBubble';
import SelectTaskGroupPopout from 'components/SelectTaskGroupPopout';
import SelectMilestonePopout from 'components/select-milestone-popout';
import ColorPicker from 'components/color-picker';
import SelectCustomFieldPopout from 'components/SelectCustomFieldPopout';
import CustomFieldName from 'components/CustomFieldName';
import CustomFieldIcon from 'components/CustomFieldIcon';

import IconRoadmap from 'icons/icon-roadmap';
import IconEye from 'icons/icon-eye';
import IconArrowDown from 'icons/icon-arrow-down';
import IconArrowRight from 'icons/icon-arrow-right';
import IconMoreHoriz from 'icons/icon-more-horiz';

class TaskGroupHead extends PureComponent {
    static contextType = RolesAndPermissionsContext;

    static defaultProps = {
        draggable: true
    }

    state = {
        editing: false,
        dropdownVisible: false
    }

    get hasDoubleClick() {
        return !(this.props.hideUtils || this.props.isStatic || this.props.publicPage);
    }

    handleDoubleClick = () => {
        if (!this.hasDoubleClick) {
            return;
        }

        this.doubleClicked = true;
        this.beginEditing();

        setTimeout(() => {
            this.doubleClicked = false;
        }, 500);
    }

    handleEditSubmit = name => {
        this.completeEditing(name);
    }

    handleEditCancel = () => {
        this.cancelEditing();
    }

    beginEditing() {
        this.setState({
            editing: true
        });

        this.props.onEditStart && this.props.onEditStart();
    }

    cancelEditing() {
        this.setState({
            editing: false
        });

        this.props.onEditEnd && this.props.onEditEnd();
    }

    completeEditing(name) {
        this.setState({
            editing: false
        });

        this.updateTaskGroup({ name });
        this.props.onEditEnd && this.props.onEditEnd();
    }

    updateTaskGroup(props) {
        updateTaskGroup(this.props.id, props);
    }

    handleMoveAllTasksConfirm = ({ id, projectId }) => {
        moveAllTaskGroupTasks(this.props.id, id, projectId);
        this.moveAllTasksCtrl && this.moveAllTasksCtrl.hide();
    }

    handleSelectTieToMilestone = milestoneId => {
        this.updateTaskGroup({ milestone: milestoneId });
        this.tieToMilestoneCtrl && this.tieToMilestoneCtrl.hide();
    }

    handleSelectRollupField = fieldId => {
        updateTaskGroupApi(this.props.id, { rollup: fieldId });
        this.setRollupCtrl && this.setRollupCtrl.hide();
    }

    handleDropdownCollapse = () => {
        this.setState({
            dropdownVisible: false
        });
    }

    handleDropdownExpand = () => {
        this.setState({
            dropdownVisible: true
        });
    }

    handleActionClick = ({ payload }) => {
        switch (payload.action) {
            case 'setAsMilestone':
                this.setAsMilestone();
                break;

            case 'rename':
                this.beginEditing();
                break;

            case 'changeColor':
                this.colorPickerCtrl && this.colorPickerCtrl.show();
                break;

            case 'archiveTasks':
                this.archiveTasks();
                break;

            case 'complete':
                this.completeTaskGroup();
                break;

            case 'delete':
                this.removeTaskGroup();
                break;

            case 'duplicateTaskGroup':
                duplicateTaskGroup(this.props.id);
                break;

            case 'moveAllTasks':
                this.moveAllTasksCtrl && this.moveAllTasksCtrl.show();
                break;

            case 'hideFrom':
                this.hideFromCtrl && this.hideFromCtrl.show();
                break;

            case 'tieToMilestone':
                tieToMilestone(this.props.id);
                // this.tieToMilestoneCtrl && this.tieToMilestoneCtrl.show();
                break;

            case 'untieFromMilestone':
                untieFromMilestone(this.props.id);
                // this.tieToMilestoneCtrl && this.tieToMilestoneCtrl.show();
                break;

            case 'setRollup':
                this.setRollupCtrl && this.setRollupCtrl.show();
                break;

            case 'removeRollup':
                updateTaskGroupApi(this.props.id, { rollup: null });
                updateTaskGroup(this.props.id, { rollup: null }, true);
                break;

            case 'deleteArchivedTasks':
                this.deleteArchivedTasks();
                break;

            case 'archiveCompletedTasks':
                this.archiveCompletedTasks();
                break;

            default: 
                return null;
        }
    }

    setAsMilestone() {
        createMilestone({
            project: this.props.projectId,
            task_group: this.props.id,
            start: new Date(),
            end: new Date().getTime() + 1000 * 60 * 60 * 24 * 7
        }).then(({ id }) => {
            this.props.onMilestoneOpen && this.props.onMilestoneOpen(id, true);
            this.setState({
                currentMilestoneId: id,
                showMilestoneDatepicker: true
            });

            trackEvent('MILESTONE.CREATE', {
                via: 'Task list set as milestone'
            });
        });
    }

    handleAssigneeRemove = userId => {
        unassignTaskGroup(this.props.id, [userId]);
    }

    handleAssigneeAdd = user => {
        assignTaskGroup(this.props.id, [user.id || user]);
    }

    handleMilestoneClick = () => {
        this.props.onMilestoneOpen && this.props.onMilestoneOpen(this.props.milestone);
    }

    handleToggle = () => {
        this.props.onToggle && this.props.onToggle(this.props.id);
    }

    archiveTasks() {
        // TODO
        trackEvent('TASKLIST.ARCHIVE');

        archiveTasks({
            task_group_id: this.props.id
        });
    }

    async removeTaskGroup() {
        trackEvent('TASKLIST.REMOVE');

        await archiveTasks({
            task_group_id: this.props.id
        });

        removeTaskGroup(this.props.id);
    }

    completeTaskGroup() {
        trackEvent('TASKLIST.COMPLETE');

        if (this.props.tasks.length) {
            completeTasks(this.props.tasks);
        }
    }

    deleteArchivedTasks() {
        removeTasks({
            project_id: this.props.projectId,
            archived: true
        });
    }

    archiveCompletedTasks() {
        archiveTasks({
            project_id: this.props.projectId,
            completed: true
        });
    }

    handleHide = roleIds => {
        setTaskGroupVisibility(this.props.id, false, roleIds);
    }

    handleReveal = roleIds => {
        setTaskGroupVisibility(this.props.id, true, roleIds);
    }

    handleColorChange = color => {
        this.updateTaskGroup({ color });
    }

    setColorPickerCtrl = ctrl => this.colorPickerCtrl = ctrl;
    setMoveAllTasksCtrl = ctrl => this.moveAllTasksCtrl = ctrl;
    setHideFromCtrl = ctrl => this.hideFromCtrl = ctrl;
    setTieToMilestoneCtrl = ctrl => this.tieToMilestoneCtrl = ctrl;
    setSetRollupCtrl = ctrl => this.setRollupCtrl = ctrl;

    get archivedActionItems() {
        const { t } = this.props;

        return [
            {
                text: t('actions.Delete all archived tasks'),
                payload: {
                    action: 'deleteArchivedTasks'
                }
            }
        ];
    }

    get completedActionItems() {
        const { t } = this.props;

        return [
            {
                text: t('actions.Archive all completed tasks'),
                payload: {
                    action: 'archiveCompletedTasks'
                }
            }
            ];
    }

    get defaultActionItems() {
        const { t } = this.props;
        const result = [];

        if (!this.props.milestone && config.MILESTONE_TASK_LISTS_ENABLED) {
            result.push({
                text: t('actions.Set status as milestone'),
                payload: {
                    action: 'setAsMilestone'
                }
            });

        }

        result.push(
            {
                text: t('common:Rename'),
                payload: {
                    action: 'rename'
                }
            },
            {
                text: t('actions.changeColor.title'),
                payload: {
                    action: 'changeColor'
                }
            },
            {
                text: t('actions.Duplicate status'),
                payload: {
                    action: 'duplicateTaskGroup'
                }
            }
        );


        if (this.props.tasks) {
            result.push(
                {
                    text: t('actions.Complete all tasks'),
                    payload: {
                        action: 'complete'
                    }
                },
                {
                    text: t('actions.Move all tasks from this status'),
                    payload: {
                        action: 'moveAllTasks'
                    }
                }
            );
        }

        result.push(
            {
                text: t('actions.Hide status from'),
                payload: {
                    action: 'hideFrom'
                }
            }  
        );

        if (!this.props.milestone) {
            result.push(
                {
                    text: t('actions.tieToMilestone.title'),
                    payload: {
                        action: 'tieToMilestone'
                    }
                }
            );
        } else {
            result.push(
                {
                    text: t('actions.untieFromMilestone.title'),
                    payload: {
                        action: 'untieFromMilestone'
                    }
                }
            );
        }

        if (this.props.rollup?.fieldId) {
            result.push(
                {
                    text: t('actions.removeRollup.title'),
                    payload: {
                        action: 'removeRollup'
                    }
                }
            );
        } else {
            result.push(
                {
                    text: t('actions.setRollup.title'),
                    payload: {
                        action: 'setRollup'
                    }
                }
            );
        }


        if (this.context?.canUser('removeTaskGroup')) {
            result.push(
                {
                    text: t('actions.archiveAll.title'),
                    payload: {
                        action: 'archiveTasks'
                    },
                    prompt: {
                        title: t('actions.archiveAll.title'),
                        text: t('actions.archiveAll.description'),
                        confirmText: t('actions.archiveAll.confirm'),
                        confirmClassName: 'btn-caution'
                    }
                },
                {
                    text: t('actions.Archive tasks and Delete status'),
                    payload: {
                        action: 'delete'
                    }
                }
            );
        }

        return result;
    }

    get actionItems() {
        if (this.props.isStatic) {
            if (this.props.archived) {
                return this.archivedActionItems;
            }
            if (this.props.completed) {
                return this.completedActionItems;
            }

            return null;
        }

        return this.defaultActionItems;
    }

    get utilsElement() {
        if (this.props.hideUtils || !this.context?.canUser('editTaskGroup') || !this.actionItems) {
            return null;
        }

        const { t } = this.props;

        return (
            <React.Fragment>
                <DropdownBtn
                    btnClassName="btn btn-icon btn-small"
                    onItemClick={this.handleActionClick}
                    onDropdownShow={this.handleDropdownExpand}
                    onDropdownHide={this.handleDropdownCollapse}
                    items={this.actionItems}
                    tooltip={ t('common:More options') }
                >
                    <IconMoreHoriz />
                </DropdownBtn>

                <ColorPicker
                    compact={true}
                    xAlign="right"
                    defaultXPosition="left"
                    withTransparent={true}
                    selected={this.props.color}
                    onSelect={this.handleColorChange}
                    provideController={this.setColorPickerCtrl}
                />

                <HideFrom
                    hidden={this.props.hidden}
                    xAlign="right"
                    defaultXPosition="left"
                    provideController={this.setHideFromCtrl}
                    onHide={this.handleHide}
                    onReveal={this.handleReveal}
                />

                <SelectTaskGroupPopout
                    title={ t('actions.Move tasks') }
                    xAlign="right"
                    defaultXPosition="left"
                    selected={this.props.id}
                    projectId={this.props.projectId}
                    withoutSelectTrigger={true}
                    onSelect={this.handleMoveAllTasksConfirm}
                    provideController={this.setMoveAllTasksCtrl}
                />

                <SelectMilestonePopout
                    title={ t('actions.tieToMilestone.title') }
                    xAlign="left"
                    defaultXPosition="right"
                    // selected={this.props.id}
                    projectId={this.props.projectId}
                    onSelect={this.handleSelectTieToMilestone}
                    provideController={this.setTieToMilestoneCtrl}
                />

                <SelectCustomFieldPopout
                    title={ t('actions.setRollup.popoutTitle') }
                    xAlign="left"
                    defaultXPosition="right"
                    association="task" 
                    selected={this.props.rollup?.fieldId}
                    projectId={this.props.projectId}
                    onSelect={this.handleSelectRollupField}
                    provideController={this.setSetRollupCtrl}
                />
            </React.Fragment>
        )
    }

    render() {
        const { t } = this.props;

        if (this.state.editing) {
            return (
                <div className="task-group-head">
                    <EditPanel
                        placeholder={`${t('Status Name')}…`}
                        defaultValue={this.props.name}
                        actionText={ t('common:Update') }
                        onSubmit={this.handleEditSubmit}
                        onCancel={this.handleEditCancel}
                        autoUpdate={true}
                        autoHeight={true}
                        autoFocus={true}
                        noClose={true}
                    />
                </div>
            );
        }

        const color = this.props.id === 'completed' ? '#02bdad' : this.props.color;

        return (
            <div ref={this.props.innerRef} className={'task-group-head' + (this.props.draggable ? ' draggable' : '') + (this.state.dropdownVisible ? ' action-dropdown-visible' : '') + (this.props.onClick ? ' clickable' : '')}>
                { color ? <div className="color-code" style={{ backgroundColor: color }} /> : null }

                {
                    this.props.milestone ? (
                        <div className="task-group-head-block" onClick={this.handleMilestoneClick}><IconRoadmap /></div>
                    ) : null
                }

                {
                    !(this.props.hideAssignees || !this.context?.canUser('editTaskGroup')) ? (
                        <UsersList
                            popoutTitle={`${t('actions.assignTaskList.title')}:`}
                            projectId={this.props.projectId}
                            editable={this.context?.canUser('editTaskGroup')}
                            size="xsmall"
                            border={true}
                            users={this.props.assignees}
                            roles={this.context?.getRoles()}
                            maxUsersCount={2}
                            popoutSize="xxsmall"
                            subtitles={this.context?.canUser('editTaskGroup') ? 'Un-assign user' : null}
                            emailMatchText={ t('actions.assignTaskList.invite.match') }
                            noMatchText={ t('actions.assignTaskList.invite.noMatch') }
                            closeOnEveryClick={true}
                            onSubtitleClick={this.handleAssigneeRemove}
                            excludedUsers={this.props.assignees}
                            onUserSelect={this.handleAssigneeAdd}
                            addUserTooltip={ t('actions.assignTaskList.tooltip') }
                        />
                    ) : null
                }

                {
                    this.props.hidden?.length ? (
                        <Tooltip tooltip={<span>{ t('Status hidden from', { roles: this.context?.getRolesListString(this.props.hidden, true) }) }</span>}>
                            <div className="task-group-icon">
                                <IconEye />
                            </div>
                        </Tooltip>
                    ) : null
                }

                <div className="group-head-main">
                    <OverflowTooltip placement="top">
                        <span className="group-label" onDoubleClick={this.handleDoubleClick} onClick={(!this.hasDoubleClick && this.props.onToggle) ? this.handleToggle : undefined}>
                            { this.props.isStatic ? t(`common:${this.props.name}`) : this.props.name }
                        </span>
                    </OverflowTooltip>

                    {
                        this.props.tasksCount ? <span className="label-bubble">{this.props.tasksCount}</span> : null
                    }

                    {
                        this.props.rollup?.fieldId ? (
                            <Tooltip tooltip={ <CustomFieldName id={this.props.rollup.fieldId} /> }>
                                <span className="label-bubble"><CustomFieldIcon id={this.props.rollup.fieldId} useCurrencySymbol={true} /> { this.props.rollup.value }</span>
                            </Tooltip>
                        ) : null
                    }

                    {
                        this.props.notificationsCount ? (
                            <NotificationsBubble count={this.props.notificationsCount} typeLabel={true} />
                        ) : null
                    }
                </div>

                { this.utilsElement }

                {
                    !this.props.publicPage && this.props.onToggle ? (
                        <Tooltip tooltip={(this.props.collapsed ? t('common:Expand') : t('common:Collapse'))}>
                            <button className="btn btn-icon task-group-toggle" onClick={this.handleToggle}>
                                {
                                    this.props.collapsed ? <IconArrowRight /> : <IconArrowDown />
                                }
                            </button>
                        </Tooltip>
                    ) : null
                }
            </div>
        );
    }
}

export default withTranslation(['task', 'common'])(TaskGroupHead);
